import { render, staticRenderFns } from "./EntraOwners.vue?vue&type=template&id=587248ba"
import script from "./EntraOwners.vue?vue&type=script&lang=js"
export * from "./EntraOwners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports